'use strict';

/**
 * Bundle products section: detail drawer per card, and local variant selection —
 * the selected variant never reloads the page, the bundle price is fixed.
 */

const learnMorePanel = require('../utils/learnMorePanel');
const productImageResolver = require('../utils/productImageResolver');

const CARD_SELECTOR = '[data-bundle-product-card]';
const packSelect = require('../components/productPackSelect');

function syncBundleAvailability() {
	const cards = Array.from(document.querySelectorAll(CARD_SELECTOR));
	if (!cards.length) {
		return;
	}
	const blocked = cards.some(function (card) {
		return card.getAttribute('data-bundle-available') !== 'true' || card.getAttribute('aria-busy') === 'true';
	});
	const $container = $('.product-detail').has('.cart-and-ipay').first();
	const hasPrice = document.querySelector('[data-bundle-has-price]').getAttribute('data-bundle-has-price') === 'true';
	$container.find('.product-availability').data('available', !blocked).data('ready-to-order', !blocked);
	$('body').trigger('product:updateAddToCart', {
		$productContainer: $container,
		product: { available: !blocked, readyToOrder: !blocked, hasPrice: hasPrice }
	});
}

function selectVariation(card, url) {
	if (!url || card.getAttribute('aria-busy') === 'true') {
		return;
	}
	const previousMarkup = $(card).find('[data-bundle-variations]').prop('outerHTML');
	let updated = false;
	card.setAttribute('aria-busy', 'true');
	syncBundleAvailability();
	$.ajax({ url: url, data: { bundleVariation: 'true' } }).done(function (data) {
		const product = data.product;
		if (!product || !product.bundleVariationHtml) {
			return;
		}
		updated = true;
		card.setAttribute('data-selected-pid', product.id);
		const available = !!(product.available && product.readyToOrder);
		card.setAttribute('data-bundle-available', String(available));
		card.querySelector('[data-bundle-unavailable]').hidden = available;
		$(card).find('[data-bundle-variations]').replaceWith(product.bundleVariationHtml);
		packSelect.syncPackSelectUI($(card));
		packSelect.initPackSelectA11y($(card));
		const image = card.querySelector('[data-bundle-card-image]');
		const resolvedImage = productImageResolver.resolveFromImageModel(product.images);
		if (image && resolvedImage) {
			image.setAttribute('src', resolvedImage.src);
			image.setAttribute('alt', resolvedImage.alt || product.productName || '');
			image.setAttribute('title', resolvedImage.title || '');
		}
	}).always(function () {
		if (!updated) {
			$(card).find('[data-bundle-variations]').replaceWith(previousMarkup);
			packSelect.syncPackSelectUI($(card));
			packSelect.initPackSelectA11y($(card));
		}
		card.removeAttribute('aria-busy');
		syncBundleAvailability();
	});
}

function collectSelectedChildProducts() {
	const cards = document.querySelectorAll(CARD_SELECTOR);
	const children = [];

	for (let index = 0; index < cards.length; index++) {
		const card = cards[index];
		const quantity = parseInt(card.getAttribute('data-bundle-quantity'), 10);
		children.push({
			pid: card.getAttribute('data-selected-pid') || card.getAttribute('data-pid'),
			quantity: isNaN(quantity) || quantity < 1 ? 1 : quantity,
		});
	}

	return children;
}

function injectSelectedChildProductsInAddToCartForm() {
	$(document).off('updateAddToCartFormData.lvzBundleChildren');
	$(document).on('updateAddToCartFormData.lvzBundleChildren', function (event, form) {
		if (!form) {
			return;
		}
		const children = collectSelectedChildProducts();
		if (children.length) {
			form.childProducts = JSON.stringify(children);
		}
	});
}

if (!window.__lvzBundleProductsInit) {
	window.__lvzBundleProductsInit = true;

	injectSelectedChildProductsInAddToCartForm();
	$(syncBundleAvailability);

	learnMorePanel.delegatePanel({
		wrapperSelector: '.bundle-product-card__modal-wrapper',
		openSelector: '[data-bundle-modal-open]',
		panelSelector: '[data-bundle-modal-panel]',
		drawerClass: 'sa-product-features-drawer',
		labelSelector: '[data-bundle-modal-title]',
	});

	$(document).on('click.lvzBundleVariation', CARD_SELECTOR + ' .product-tile__swatch-btn', function (event) {
		event.preventDefault();
		if (!this.querySelector('.selected')) {
			selectVariation(this.closest(CARD_SELECTOR), this.getAttribute('data-url'));
		}
	});

	$(document).on('bundle:variation.lvzBundleVariation', CARD_SELECTOR + ' select', function (event, url) {
		event.stopPropagation();
		selectVariation(this.closest(CARD_SELECTOR), url);
	});
}
